<template>

  <div style="display: inline-flex;margin-bottom: 20px;margin-top: 5px;margin-left: 5px">

    <el-date-picker v-model="currentMonth" type="month" placeholder="请选择月份" style="margin-right: 20px"
    />

    <el-button @click="getReportData" >查询</el-button>
  </div>
  <el-table :data="reportList" stripe style="width: 100%;height: 90%" row-style="height:35px;" size="small">
    <el-table-column v-for="month in monthList" :key="month.title"
                     :prop="month.title" :fixed="month.fixed" :width="month.width"
                     align="center">
      <template #header>
        <div class="myHeader">{{month.week}}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

import moment from "moment";

export default {
  name: "DailyRebuildReport",
  data() {
    return {
      currentKpiData:{},
      currentMonth:new Date(),
      originTitle: [ '新增订单改机数量', '改机完成数量', '待改机数量',"正常未出货数量","异常未出货数量","合计未出货","按时完成量","达成率","正常未出货金额","异常未出货金额","合计"],
      monthList: [],
      reportList: [],
      transData:[]
    }
  },
  methods: {
    async getReportData() {
      if(!this.currentMonth){
        return this.$message.error("请选择月份")
      }
      let queryParam ={currentMonth: moment(new Date(this.currentMonth)).format('yyyy-MM-DD')};
      //查询数据
      let rtn = await this.$http('rebuildDailyReportService.getRebuildReportList', queryParam)
      if(!rtn || !rtn.day_list){
        return this.$message.error("返回的数据格式不正确")
      }
      //赋值
      this.monthList = rtn.day_list;
      this.reportList = rtn.report_list;
    }
  },
  mounted() {
    this.getReportData()
  }
}
</script>


<style lang="less" scoped>
@import 'src/global';

.myHeader {
  white-space: pre-wrap !important;   /*这是重点。文本换行*/
}

.myContainer {
  padding: 5px;
}

</style>